<template>
  <div class="lianghui" @click="bodyclick()">
      <div class="lianghui-top">
          <img :src="ai_option.plate_log" v-show="ai_option.plate_log">
      </div>


      <div class="videoContainner">
          <div class="video" :style="{height:Videoheight+'px'}">


              <simpleVideo v-if="video" :src="video" :height="Videoheight" :poster="poster" :playEndFun="playEnd"></simpleVideo>

              <div class="noVideo" >
                  <vue-baberrage
                          :isShow="showbarrage"
                          :boxHeight="Videoheight"
                          :barrageList="barrageList"
                          :loop="true"
                  ></vue-baberrage>
              </div>
          </div>


      </div>

<!--      <div class="nav">-->
<!--          <div class="nav-btn" @click="setShowVideo(false)">-->
<!--              <img src="../assets/kan.png">-->
<!--          </div>-->
<!--          <div class="nav-line"></div>-->
<!--          <div class="nav-btn" @click="setShowVideo(true)">-->
<!--              <img src="../assets/tin.png">-->
<!--          </div>-->
<!--      </div>-->

      <div class="lianghui-controller">
          <div class="dingz-btn" @click1="showFenlei = true" @click.stop="showTag()" :class="{active:ShowTag}">

              <span>{{ai_option.plate_keyword_title}}</span>
              <div>
                  <svg t="1615192540336" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2218" width="200" height="200"><path d="M512 736C512 736 512 736 512 736c-6.4 0-19.2-6.4-25.6-12.8L76.8 320c-12.8-12.8-12.8-38.4 0-51.2C89.6 256 108.8 256 121.6 268.8l390.4 384 390.4-384c12.8-12.8 38.4-12.8 51.2 0 12.8 12.8 12.8 38.4 0 51.2l-409.6 403.2C531.2 729.6 518.4 736 512 736 512 736 512 736 512 736z" p-id="2219" fill="#bfbfbf"></path></svg>
              </div>
          </div>
          <div class="barrage-btn">
              <span>{{showbarrage?"关闭弹幕":"开启弹幕"}}</span>
              <van-switch v-model="showbarrage"  size="18px" active-color="rgb(221,89,120) "/>
          </div>

          <div class="tag-containner" @click.stop>
              <div class="wodelianghui-tag">
                  <div v-for="item in tags" :class="{active:selectTage[item.cate_code]}" @click="selectCode(item)">{{item.cate_name}}</div>
              </div>
          </div >



      </div>

      <div class="lianghui-list" :style="{height:listHeight+'px'}">
            <div class="lianghui-list-containner"  ref="listContainner"  :style="{height:listHeight-70+'px'}">

                <div class="lianghui-item" v-for="(item,index) in list" :ref="'list'+index" @click="play(index)" :class="{active:index===currentIndex}">
                    <div class="lianghui-item-title">{{item.title}} <span v-if="index===currentIndex">正在播放</span> <span v-if="item.onlive_url">直播</span></div>
                    <div class="lianghui-item-row">
                        <div class="lianghui-item-row-left">
                            <div class="lianghui-item-row-des ">{{item.description}}


                            </div>
                            <div class="viewContent" @click.stop="toContent(item.news_id)" v-if="item.news_id">
                                <span>阅读图文</span>
                                <img src="../assets/next.png">
                            </div>
                        </div>
                        <img :src="item.onlive_img" class="lianghui-item-row-img" v-if="item.onlive_url">
                        <img :src="item.cover_url" class="lianghui-item-row-img" v-else>


                    </div>

                </div>


            </div>

          <div class="lianghui-bottomBar">
              <div class="lianghui-bottomBar-containner">
                  <input type="text" class="liuyan-input" placeholder="我要发言…" v-model="message">
                  <div class="lianghui-bottomBar-btn" @click="send()">
                      <img src="../assets/send.png">
                  </div>


              </div>
          </div>
      </div>



<!--      选择我的两会-->
<!--      <van-dialog v-model="showFenlei" title="选择我的两会标签" show-cancel-button @confirm="closeDialog()">-->
<!--          <div class="wodelianghui-tag">-->
<!--                <div v-for="item in tags" :class="{active:selectTage[item.cate_code]}" @click="selectCode(item)">{{item.cate_name}}</div>-->
<!--          </div>-->
<!--      </van-dialog>-->






  </div>
</template>

<style scoped>



    body,html{ padding: 0; margin: 0}

.lianghui{ position: absolute; width: 100%; height: 100vh;  left: 0; top:0; background-color: #fff;  min-height: 550px; overflow-y: scroll;background-color: #f2f2f2 }
@media screen and (max-height: 550px) {
    .lianghui{ height: 550px !important;}
}
    .lianghui-top img{ width: 100%; height: 50px; display: block}
    .nav{ display: flex; justify-content: space-between; align-items: center; height: 60px;box-shadow: 0 0 5px rgba(0,0,0,0.2)}
    .nav-btn{ height: 60px; display: flex; justify-content: center; align-items: center; position: relative;
        flex: 1; background-color: #fff; }
    .nav-btn img{ height: 30px}
    .nav-line{ height: 30px; width: 1px; background-color: #cccccc}
    .video{ position: relative; overflow: hidden}
    .noVideo{ position: absolute; width: 100%; left: 0; top: 0; bottom:0; pointer-events: none; z-index: 100; transform: translate3d(0,0,0);
        -webkit-transform:translate3d(0,0,0);
    }
    .noVideo-img{ width: 100%; height: 100%;}
    .video video{ display: block; width: 100%; height: 100%}
    video{ height: 100%}
    .lianghui-list{ width: 100%;
    }
    /*列表*/
    .lianghui-item{  padding:15px 15px; position: relative;}
    .lianghui-item:after{ content: " "; position: absolute; left: 0; bottom:0; width: 100%; height: 1px; transform: scaleY(0.5); background-color: #cccccc}
    .lianghui-item-icon{ width: 30px; height: 30px; margin-right: 15px}
    .lianghui-item-icon svg{ width: 30px; height: 30px;}
    .lianghui-item.active .lianghui-item-icon svg path{ fill: red !important;}
    .lianghui-item-title{ flex: 1; font-size: 16px; line-height: 1.2; margin-right: 10px; font-weight: bold; margin-bottom: 10px;-webkit-box-orient: vertical;
        -webkit-line-clamp: 2;}
    .lianghui-item.active .lianghui-item-title{ color: red}
    .lianghui-item-row-left{ display: flex; flex-direction: column; justify-content: space-between; align-content: space-between;margin-right: 10px}
    .lianghui-item-row{ display: flex; justify-content: space-between; align-items: center}
    .lianghui-item-row-img{ width: 90px; height: 60px; border-radius: 4px; object-fit: cover}
    .viewContent{ display: flex;align-items: center; font-size: 13px; color: #6e6e6e;
    height: 24px;  border-radius: 5px; border-top-right-radius: 0;  border-bottom-right-radius: 0; margin-top: 6px}

    .viewContent img{ height: 12px; margin-left: 5px}
    .text-overflow{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .lianghui-item-row-des{ color: #919191;min-height: 32px; line-height: 16px; font-size: 12px}
    .lianghui-item-title span{ display: inline-block; vertical-align: middle; font-size: 10px;background-color: red; color: #fff; height: 16px;
    line-height: 16px; border-radius: 3px; padding: 0 4px}
    .lianghui-list-containner{ overflow-y:scroll}

    .lianghui-bottomBar{ padding: 0 15px; display: flex; justify-content: center; align-items: center; height: 70px; position: fixed; width: 100%; left: 0; bottom:0}
    .lianghui-bottomBar-containner{ height: 50px; background-color: #fff; border-radius: 10px; width: 100%; overflow: hidden;
    box-shadow: 0 0 10px rgba(174,79,0,0.2); display: flex; justify-content: space-between; align-items: center;padding-left: 10px}
    .liuyan-input{ display: flex;flex:1; height: 36px; border-radius: 36px;
        background-image: -webkit-linear-gradient( 90deg, rgb(255,136,124) 0%, rgb(221,89,120) 100%); padding: 0 10px;
        color: #fff; font-size: 14px;
    }
    .liuyan-input::-webkit-input-placeholder { /* WebKit browsers */
        color: #fff;

    }
    .lianghui-bottomBar-btn{ display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 0 10px; margin: 0 5px}
    .lianghui-bottomBar-btn img{ height: 24px; display: block; width: 25px}
    /*.lianghui-bottomBar-btn span{ font-size: 10px}*/
    .dingz-btn{padding: 0 10px;
    height: 40px; color: #000; font-size: 16px; display: flex; justify-content: center; align-items: center; flex-direction: column}
    .dingz-btn span{ font-weight: bold}
    .dingz-btn>div{width: 14px; height: 14px; transform: rotate(0); transition: 0.3s}
    .dingz-btn.active>div{transform: rotate(180deg)}
    .dingz-btn svg{ width: 14px; height: 14px}
    /*.dingz-btn div{ display: flex; width: 40px; height: 40px; justify-content: center; align-items: center}*/
    .wodelianghui-tag{width: 100%; max-height: 60vh; overflow-y: scroll; padding: 15px ; display: flex;  flex-wrap: wrap;box-shadow:0 5px 5px rgba(0,0,0,0.2); background-color: #f9f9f9; }
    .wodelianghui-tag >div{ line-height: 30px; padding: 0 15px; margin:5px; border-radius: 24px; color: rgb(255, 183, 169); border: 1px solid rgb(255, 183, 169)
    }
    .wodelianghui-tag>.active{ color: #fff; background-color:rgb(255, 183, 169)}
    .lianghui-controller{ display: flex; justify-content: center; align-items: center; padding: 0 15px; height: 40px; padding-left: 0; position: relative; background-color: #fff}
    .lianghui-controller>div{ display: flex; align-items: center}
    .barrage-btn span{ font-size: 12px; color: #999999; display:block; margin-right: 5px}
    .barrage-btn{ position: absolute; right: 10px; bottom:0; display: flex; align-content: center; height: 40px;}

    .tag-containner{ position: absolute; width: 100%; left: 0; top:40px; z-index: 10; overflow:hidden; transition: 0.3s; height: 0}







</style>
<style>
    .baberrage-item .normal .baberrage-avatar{ display: none !important;}
    .baberrage-item .baberrage-msg{ line-height: 14px !important; font-size: 12px}
    .baberrage-item .normal{ background-color: transparent !important;}
</style>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { vueBaberrage } from 'vue-baberrage'
Vue.use(vueBaberrage);





import { MESSAGE_TYPE } from 'vue-baberrage'

import simpleVideo from '@/components/simpleVideo.vue'

import {gsap,TweenLite} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

import { Toast } from 'vant';
import request from "../utils/request";
import utils from "../utils";
export default {
  name: 'Home',
    data(){
      return {
          showFenlei: false,
          showVideo:false,
          video:'',
          poster:'',
          Videoheight:parseInt(window.innerWidth/1.7777),
          listHeight:100,
          currentIndex:0,
          barrageList:[],
          showbarrage:true,//显示弹幕
          message:'',//发送弹幕
          tags:[],
          tagstr:'',
          selectTage:{},
          dmlist:[],
          list:[],
          ShowTag:false,
          id:1,
          ai_option:{},
          itemid:''

      }
    },
  components: {
      simpleVideo
  },
    created() {

        // try{
        //
        //
        //     var list = localStorage.getItem("ailist");
        //     if(list){
        //         list = JSON.parse(list);
        //         if(list && list.length>0){
        //             this.list = list;
        //             if(list[this.currentIndex].onlive_url){
        //                 this.video = list[this.currentIndex].onlive_url;
        //                 this.poster =list[this.currentIndex].onlive_img
        //             }else{
        //                 this.video = list[this.currentIndex].play_url;
        //                 this.poster = this.video+'?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast'
        //             }
        //         }
        //
        //     }
        //
        //
        //
        //
        // }catch (e) {
        //
        // }
        this.itemid = this.getQueryVariable("itemid");
        setTimeout(()=>{
            if(this.getQueryVariable("id")){
                this.id = this.getQueryVariable("id")
                setTimeout(()=>{
                    this.get_ai_option()
                    this.getAiList();
                    this.get_ai_category();
                    this.initShare()
                },10)
            }else{
                this.get_ai_option()
                this.getAiList();
                this.get_ai_category();
                this.initShare()
            }
        },0)



      var winheight = window.innerHeight;
      if(winheight<550){
          winheight = 550
      }
        this.listHeight = winheight - 50-40 - parseInt(window.innerWidth/1.7777);
      window.onresize = ()=>{
          this.Videoheight = parseInt(window.innerWidth/1.7777);
          this.listHeight = winheight - 50-40 - parseInt(window.innerWidth/1.7777);


      };
      // this.video = this.list[this.currentIndex].play_url;

    },
    mounted() {
      this.get_board();
      setTimeout(()=>{
          request.data_statistics({type:5})
      },200)
    },
    methods:{
        getQueryVariable(variable)
        {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
            }
            return(false);
        },
      /*
      * 获取配置
      * */
        get_ai_option(){
            if(!this.id){
                this.id = 1;
            }
            request.get_ai_option(this.id,(res)=>{
                if(res && res.data){
                    this.ai_option = res.data;
                    this.initShare()
                }
            })
        },
        bodyclick(){

            if(this.ShowTag){
                this.ShowTag = false;
                this.closeDialog()
                document.querySelector(".tag-containner").style.height = 0;
                document.querySelector(".tag-containner").style.paddingBottom = 0
            }
        },
        showTag(){
            this.ShowTag = !this.ShowTag;
            var h = 0;
            var paddingbottom = 0;
            if(this.ShowTag){
                 h = document.querySelector(".wodelianghui-tag").clientHeight;
                paddingbottom = 20
            }else{
                this.closeDialog()
            }

            document.querySelector(".tag-containner").style.height = h+'px';
            document.querySelector(".tag-containner").style.paddingBottom = paddingbottom+'px'
        },
        closeDialog(){
            let str = [];
            for(let x in this.selectTage){
                if(this.selectTage[x]){
                    str.push(x)
                }
            }
            if(this.tagstr !== str.join(',')){
                this.tagstr = str.join(',');
                setTimeout(()=>{
                    this.getAiList()
                },10)
            }

        },
        /*
        * 选择分类标签
        * */
        selectCode(item){
            if(this.selectTage[item['cate_code']]){
                this.selectTage[item['cate_code']] = false
            }else{
                this.selectTage[item['cate_code']] = true
            }
            this.$forceUpdate()
        },
      /*
      * 获取视频列表
      * */
      getAiList(){
          let keywords = this.tagstr;


          request.get_ai_list({id:this.id,keywords:keywords},(res)=>{
              try{
                  var itemid = this.itemid;
                  if(itemid && !keywords){
                      var list = [];
                      res.data.map(d=>{
                          if(d.id ==itemid){
                              list.push(d);
                              if(d.onlive_url){
                                  this.video = d.onlive_url;
                                  this.poster =d.onlive_img
                              }else{
                                  this.video = d.play_url;
                                  this.poster = d.cover_url
                              }
                          }
                      });
                      this.list = list
                  }else{
                      this.list = res.data;
                      if(res.data[this.currentIndex].onlive_url){
                          this.video = res.data[this.currentIndex].onlive_url;
                          this.poster = res.data[this.currentIndex].onlive_img
                      }else{
                          this.video = res.data[this.currentIndex].play_url;
                          this.poster = res.data[this.currentIndex].cover_url
                      }
                  }



                  this.$forceUpdate()

              }catch (e) {

              }
          })
      },
        /*
        * 获取AI视频标签
        * */
        get_ai_category(){
            request.get_ai_category(this.id,(res)=>{


                try{
                    this.tags = res.data
                }catch (e) {

                }

            })
        },
        /*
        * 获取弹幕
        * */
        get_board(){
            var id = this.getQueryVariable("id");
            if(!id){
                 id = 1
            }
            request.get_board(id,res=>{
                this.dmlist = res.data;
                setTimeout(this.danmu,10)
            })
        },
      initShare(){



          request.getWeixinShanre(location.href,(s_res)=>{
              let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
              let shareconfig = {appId,timestamp,nonceStr,signature};


              let shareurl = location.href;
              var title = this.ai_option.share_title;
              var desc = this.ai_option.plate_description;
              if(this.getQueryVariable("itemid")){
                  title = this.list[0].title;
                  desc = this.list[0].description;
                  if(this.list[0].onlive_img){
                      thumb = this.list[0].onlive_img
                  }else if(this.list[0].cover_url){
                      thumb = this.list[0].cover_url
                  }

              }
              if(utils.is_weixin()){
                  if(s_res.data.appId){
                      let sharedata = {
                          title:title,
                          desc:desc,
                          link:shareurl,
                          imgUrl:thumb
                      };
                      utils.setWeiXinShare(sharedata,shareconfig,false)
                  }
              }
          });
      },
      toContent(id){
          this.$router.push({name:"NewsContent2",params: { id:id}})
      },
      danmu(){
          var list = [];
          this.dmlist.map((d,i)=>{
              var extraWidth = 40;
              try{
                  extraWidth = (d.content.length+1)*14+40
              }catch (e) {

              }
              let data = {
                  id:i,
                  msg:d.content,
                  time:12,

                  type: MESSAGE_TYPE.NORMAL,
                  extraWidth:extraWidth,
              }
              list.push(data)
          });

          this.barrageList = list;
          this.$forceUpdate();
          console.log(this.barrageList)

      },
        play(index){
            this.currentIndex = index;
            if(this.list[this.currentIndex].onlive_url){
                this.video = this.list[this.currentIndex].onlive_url;
                this.poster =  this.list[this.currentIndex].onlive_img;
            }else{
                this.video = this.list[this.currentIndex].play_url;
                this.poster =  this.list[this.currentIndex].cover_url;

            }
            request.data_statistics({id:this.list[this.currentIndex].id,type:1});
            setTimeout(this.scrollToItem,0)
        },
        setShowVideo(type){
            this.showVideo = type
        },
        //视频播放完成回调
        playEnd(){

            if(this.currentIndex === this.list.length-1 && this.currentIndex !==0){
                this.currentIndex = 0;
                this.getAiList();
                this.get_board()
            }else{
                this.currentIndex ++
            }
            if(this.list[this.currentIndex].onlive_url){
                this.video = this.list[this.currentIndex].onlive_url;
                this.poster =  this.list[this.currentIndex].onlive_img;
            }else{
                this.video = this.list[this.currentIndex].play_url;
                this.poster =  this.list[this.currentIndex].cover_url;
            }
            request.data_statistics({id:this.list[this.currentIndex].id,type:1});
            setTimeout(this.scrollToItem,0)

        },
        //滚动到指定视频条目
        scrollToItem(){
            var item = this.$refs['list'+this.currentIndex][0];
            var h = item.offsetTop - 110 - parseInt(window.innerWidth/1.7777);
            var listContainner = document.querySelector(".lianghui-list-containner");
            TweenLite.to(this.$refs.listContainner, 0.3, {scrollTo:h});
            if(!item) return;
        },
        // 弹幕相关开始------------------------
        send(){
            if(!this.message) {
                Toast('请输入内容');
                return
            }
            var extraWidth = 40;
            try{
                extraWidth = (this.message.length+1)*14+40
            }catch (e) {

            }
            let data = {
                id:this.barrageList.length+1,
                msg:this.message,
                time:7,
                type: MESSAGE_TYPE.NORMAL,
                extraWidth:extraWidth
            };
            this.barrageList.push(data);


            request.preserve_board({content:this.message,id:this.id},(res)=>{
                console.log(res)
                if(res && res.code===200){
                    Toast('发布成功');
                }else{
                    Toast('发布失败');
                }
            });
            this.message = ''
        },
    }
}
</script>
